import React, { useMemo, useEffect, useState } from 'react'
import tripstoday from '../../../../assets/images/slotplanning/tripstoday.svg';
import onpremises from '../../../../assets/images/slotplanning/onpremises.svg';
import inprogress from '../../../../assets/images/slotplanning/inprogress.svg';
import arriving from '../../../../assets/images/slotplanning/arriving.svg';
import { Modal, Form, Button } from "react-bootstrap";
import { useGetCargoDamageForwardersQuery, useToggleSlotStatusMutation } from '../../../../redux/services/SPL';
import CommonCard from '../../../../Components/common/CommonCard';
import TableFilters from '../../../../Components/common/TableGrid/TableFilters';
import TableTabs from '../../../../Components/common/TableGrid/TableTabs';
import { ReactComponent as ArchiveIcon } from "../../../../assets/images/slotplanning/archive_icon.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/slotplanning/edit_gatein.svg";
import { ReactComponent as ClearIcon } from "../../../../assets/images/clear.svg";
import { onTabChange, clearSelectedRowsData } from '../../../../redux/features/table/tableSlice';
import { useSelector, useDispatch } from 'react-redux';
import TableGrid from "../../../../Components/common/TableGrid";
import { ReactComponent as EyeIcon } from "../../../../assets/images/slotplanning/Eye_Icon 1.svg";
import { CallApi, getTodayDateTime } from '../../../../Components/common/CommonFunctions';
import { toast } from 'react-toastify';
import ConfModal from '../../../../Components/common/ConfModal';
const Trips = () => {

  const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);
  const [warehouse, setWarehouse] = useState([]);
  const [formData, setFormData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalConf, setModalConf] = useState(false);
  const [modalPos, setModalPos] = useState('');
  const dispatch = useDispatch();
  const [org, setOrg] = useState([]);

  const buildFilterParams = (filtersObj) => {
    const entries = Object.entries(filtersObj);
    const params = {};

    if (!entries.length) return params;

    entries.forEach(([field, value], index) => {
      params[`filtervalue${index}`] = value;
      params[`filtercondition${index}`] = "CONTAINS";
      params[`filteroperator${index}`] = 0;
      params[`filterdatafield${index}`] = field;
    });

    params.filterscount = entries.length;

    return params;
  };

  const queryParams = useMemo(() => {
    const filterParams = buildFilterParams(filters);

    const params = {
      ...filterParams,
      type: "security",
      pagenum: pageDetails.pagenum,
      pagesize: pageDetails.pagesize,
      recordstartindex: pageDetails.recordstartindex,
      recordendindex: pageDetails.recordendindex,
    };

    if (sortby?.sortdatafield) {
      params.sortdatafield = sortby.sortdatafield;
      params.sortorder = sortby.sortorder;
    }

    if (tab?.value && tab.value !== "all" && tab.key) {
      params[tab.key] = tab.value;
    }
    return params;
  }, [filters, pageDetails, sortby]);

  const { data: myData, isFetching, refetch } = useGetCargoDamageForwardersQuery(queryParams, {
    skip: pageDetails.pagesize === 0,
    refetchOnMountOrArgChange: true,
    pollingInterval: 900000,
  });
  const cards = [
    { icon: 'tripstoday', title: 'Trips Today', value: myData?.tripsToday },
    { icon: 'onpremises', title: 'On Premises', value: '0' },
    { icon: 'inprogress', title: 'In Progress', value: '0' },
    { icon: 'arriving', title: 'Arriving (Next 2h)', value: myData?.nextTwoHours },
  ]
  const iconMap = { tripstoday, onpremises, inprogress, arriving, };
  const filtersConfig = [
    {
      type: "input",
      field: "driver_name",
      placeholder: "Driver Name",
    },
    {
      type: "input",
      field: "vehicle_no",
      placeholder: "Vehicle License No.",
    },
    {
      type: "input",
      field: "trailer_no",
      placeholder: "Trailer License No.",
    },
    {
      type: "input",
      field: "truck_nos",
      placeholder: "Truck No.",
    },

  ];
  const tabsConfig = [
    { label: "All", value: "all", paramKey: null },
    { label: "Open", value: "A", paramKey: "tab" },
    { label: "Archive", value: "R", paramKey: "tab" },
  ];
  const modalGateInOpen = (row, pos) => {

    if (pos === 'A') {
      setFormData(row)
    } else {
      setFormData({ id: row.id, gate_in: row.gate_in.split(' ')[0] + ' ' + row.gate_in.split(' ')[1].substring(0, 5) })
    }
    setShowModal(true);
    setModalPos(pos)
  }
  const handleModalConf = () => {
    setModalConf(true)
  }
  const handleModalClose = () => {
    setShowModal(false);
  }
  const handleSave = (pos) => {

    let payload = {};
    if (modalPos === 'A') {
      payload = { ...formData, gate_in: getTodayDateTime(), }
    } else {
      if (pos === 'E') {
        payload = { gate_in: formData.gate_in.split('T')[0] + ' ' + formData.gate_in.split('T')[1] }
      } else {
        payload = { gate_in: '' }
      }
    }
    CallApi({
      endPoint: `trip-management/update-slot/${formData.id}`,
      method: 'patch',
      payload: payload,
      onSuccess: (res) => {
        const resCode = res.data.response_code;
        if (resCode === 200) {
          toast.success(res.data.response_msg || "Saved successfully");
          handleModalClose();
          if (pos === 'C') {
            setModalConf(false)
          }
          refetch()
        } else {
          toast.error(res.data.response_msg || "Error")
        }
      },
      onError: (msg) => toast.error(msg)
    });

  }
  const columns = [
    // {
    //   label: "", field: "actions", enableSearch: false, cls: 'single_action',
    //   renderCell: (row) => (<div className="tb_grid_actions">
    //     <EyeIcon className="row_view" style={{ cursor: "pointer" }}
    //     onClick={(e) => {
    //       e.stopPropagation();
    //       // loadDetails(row.id, "V");
    //     }}
    //   />
    //   </div>),
    // },
    {
      label: "Driver Name", field: "driver_first_name", enableSearch: false, cls: 'tw-8',
      renderCell: (row) => (<span>{row.driver1_first_name} {row.driver1_last_name}</span>)
    },
    { label: "Vehicle No", field: "vehicle_no", enableSearch: false, cls: 'tw-8' },
    { label: "Trailer No", field: "trailer_no", enableSearch: false, cls: 'tw-8' },
    {
      label: "Gate In", field: "gate_in", enableSearch: false, cls: 'tw-6',
      renderCell: (row) => (
        !row?.gate_in ? (
          <button className="edit_btn" onClick={() => { modalGateInOpen(row, 'A') }}>
            Gate In
          </button>
        ) : (
          <span>{row.gate_in.split(' ')[0] + ' ' + row.gate_in.split(' ')[1].substring(0, 5)} <EditIcon onClick={() => { modalGateInOpen(row, 'E') }} /></span>
        )
      )
    },
    { label: "Organization", field: "org_name", enableSearch: false, cls: 'tw-7' },
    { label: "Truck No.", field: "truck_nos", enableSearch: false, cls: 'tw-7' },
    { label: "Planned Time", field: "planned_date_time", enableSearch: false, cls: 'tw-8' },
    { label: "Timeslot", field: "timeslot", enableSearch: false, cls: 'tw-7' },
    { label: "Door", field: "door_no", enableSearch: false, cls: 'tw-4' },
    { label: "Warehouse", field: "warehouse_name", enableSearch: false },
    // checkbox col takes remaining ~3% automatically via the fixed <th> in Table
  ];
  const transformedRows = useMemo(() => {
    return (
      myData?.Rows?.map((item) => {
        let timeslot = "";
        if (item?.slot_start_time && item?.slot_end_time) {
          const [, startTimeFull] = item.slot_start_time.split(" ");
          const [, endTimeFull] = item.slot_end_time.split(" ");
          const startTime = startTimeFull.slice(0, 5);
          const endTime = endTimeFull.slice(0, 5);
          timeslot = `${startTime} - ${endTime}`;
        }
        return {
          ...item,
          planned_date_time: item.planned_date_time
            ? item.planned_date_time.slice(0, 16)
            : "",
          timeslot,
        };
      }) || []
    );
  }, [myData]);
  useEffect(() => {
    // if (isMounted.current) return;
    // fetchWarehousOrgnaziation();
     dispatch(onTabChange({ key: 'tab', value: "A" }));
    // isMounted.current = true;
  }, []);

  const [toggleSlotStatus, { isLoading: archiveLoading }] = useToggleSlotStatusMutation();
  const handleArchive = async (rows) => {
    try {
      const ids = rows.map((r) => r.id);
      await toggleSlotStatus({ ids: ids, type: "security" }).unwrap();
      toast.success("Status updated");
      refetch();
      dispatch(clearSelectedRowsData(true));
    } catch (err) {
      toast.error("Updation failed");
    }
  };


  const bulkActions = tab?.value === "A"
    ? [{ label: "Archive", action: handleArchive, icon: ArchiveIcon }]
    : tab?.value === "R"
      ? [{ label: "Activate", action: handleArchive, icon: ArchiveIcon }]
      : [];

  return (
    <>
      {console.log('formData', formData)}

      <div className="main-content">
        {cards?.length ?
          <div className="card-bx">
            {cards?.map((item, index) => (
              <CommonCard icon={iconMap[item.icon]} title={item.title} value={item.value} />
            ))}
          </div>
          : <></>
        }
        <div className="d-flex justify-content-between align-items-center mb-3">
          <TableFilters filtersConfig={filtersConfig} />
          <TableTabs tabs={tabsConfig} />
        </div>

        <div>
          <TableGrid
            columns={columns}
            rows={transformedRows}
            checkboxSelection={true}
            totalRecords={myData?.TotalRows || 0}
            //  onClickRow={(row) => {
            //    console.log("Clicked Row:", row);
            //  }}
            loading={isFetching}
            bulkActions={bulkActions}
            rowKey="id"
          />
        </div>
      </div>
      <Modal show={showModal} className='addfrom change_type set_get_in_modal' centered> {/* change_type */}
        <Modal.Header closeButton onClick={handleModalClose}>
        </Modal.Header>
        <Modal.Body>

          <h4>{modalPos === 'A' ? 'Set Gate In' : 'Edit Gate In Time'}</h4>
          <p>{modalPos === 'A' ? 'Set Gate in for incoming truck' : 'Update or Reset the Gate In Time.'}</p>
          <hr />
          {modalPos === 'A' &&
            <>
              <div className='slot-card-dv'>
                <h6>Trip Details</h6>
                <div className='gatein_box'>
                  <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-0'>
                    <Form.Label>Driver 1</Form.Label>
                    <Form.Control
                      type="text"
                      name="driver1"
                      defaultValue={`${formData?.driver1_first_name || ""} ${formData?.driver1_last_name || ""}`}
                      disabled

                    />
                  </Form.Group>
                  {/* {formData?.driver2_first_name && */}
                  <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-0'>
                    <Form.Label>Driver 2</Form.Label>
                    <Form.Control
                      type="text"
                      name="driver2"
                      defaultValue={`${formData?.driver2_first_name || ""} ${formData?.driver2_last_name || ""}`}
                      disabled
                    />
                  </Form.Group>
                  {/* } */}
                  <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-0'>
                    <Form.Label>Truck License Plate</Form.Label>
                    <Form.Control
                      type="text"
                      name="version"
                      defaultValue={formData?.vehicle_no || ""}
                      disabled
                    />
                  </Form.Group>

                  <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-0'>
                    <Form.Label>Trailer License Plate</Form.Label>
                    <Form.Control
                      type="text"
                      name="version"
                      defaultValue={formData?.trailer_no || ""}
                      disabled
                    />
                  </Form.Group>

                  <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-0'>
                    <Form.Label>Organization</Form.Label>
                    <Form.Control
                      type="text"
                      name="version"
                      defaultValue={formData?.org_name || ""}
                      disabled
                    />
                  </Form.Group>

                  <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-0'>
                    <Form.Label>Truck No.</Form.Label>
                    <Form.Control
                      type="text"
                      name="version"
                      defaultValue={formData?.truck_nos || ""}
                      disabled
                    />
                  </Form.Group>
                </div>
              </div>
              <div className='slot-card-dv'>
                <h6>Slot Information</h6>
                <div className='gatein_box'>
                  <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-0'>
                    <Form.Label>Planned Time</Form.Label>
                    <Form.Control
                      type="datetime-local"
                      name="version"
                      defaultValue={formData?.planned_date_time?.replace(" ", "T") || ""}
                      disabled
                    />
                  </Form.Group>

                  <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-0'>
                    <Form.Label>Timeslot</Form.Label>
                    <Form.Control
                      type="text"
                      name="version"
                      defaultValue={formData?.timeslot || ""}
                      disabled

                    />
                  </Form.Group>

                  <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-0'>
                    <Form.Label>Door</Form.Label>
                    <Form.Control
                      type="text"
                      name="version"
                      defaultValue={formData?.door_no || ""}
                      disabled
                    />
                  </Form.Group>

                  <Form.Group controlId="validationCustom01" className='d-flex align-items-center mb-0'>
                    <Form.Label>Warehouse</Form.Label>
                    <Form.Control
                      type="text"
                      name="version"
                      defaultValue={formData?.warehouse_name || ""}
                      disabled
                    />
                  </Form.Group>
                </div>
              </div>
              <h6>Remarks</h6>
              <div className='txt_area'>
                <Form.Control
                  as="textarea"
                  name="remarks"
                  value={formData?.remarks || ""}
                  placeholder="Remark"
                  style={{ height: '110px', padding: '0px' }}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      remarks: e.target.value
                    }))
                  }
                />
              </div>
              <div className='d-flex justify-content-between footer_dv'>
                <Button variant="contained" className="prev_btn" onClick={handleModalClose}>Cancel</Button>
                <Button className='trnext' variant="primary" onClick={handleSave}>Set Gate In</Button>
              </div>
            </>
          }
          {modalPos === 'E' &&
            <>
              <Form.Group controlId="validationCustom01" className='mb-0 planned_time'>
                <Form.Label>Gate In</Form.Label>
                <Form.Control
                  type="datetime-local"
                  name="version"
                  defaultValue={formData?.gate_in}
                  onChange={(e) => setFormData({ gate_in: e.target.value })}
                />
              </Form.Group>
              <div className='d-flex justify-content-between footer_dv'>
                <Button variant="contained" className="red_btn" onClick={handleModalConf}><ClearIcon /> Clear Gate In</Button>
                <Button className='prm_btn' variant="primary" onClick={() => handleSave('E')}>Update Gate In</Button>
              </div>
            </>
          }
        </Modal.Body >
      </Modal >

      <Modal show={modalConf} className='modal_bgw clear_gatein' centered> {/* change_type */}
        <Modal.Header closeButton onClick={() => setModalConf(false)}>
        </Modal.Header>
        <Modal.Body>
          <h4>Clear Gate In</h4>
          <hr />
          <p>Are you sure you want to clear the Gate In time for this?
            The Gate In time will be removed, and the trip will be moved back to active.</p>
        </Modal.Body >
        <Modal.Footer>
          <div className='d-flex justify-content-between w-100 m-0'>
            <Button variant="contained" className="ncancel_btn" onClick={() => setModalConf(false)}>Cancel</Button>
            <Button className='red_nm_btn ' variant="contained" onClick={() => handleSave('C')}>Clear Gate In</Button>
          </div>
          </Modal.Footer>
      </Modal >
    </>
  )
}

export default Trips